export const FIANLY_VERSION = '2026.10.02.2';
